/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum ApaStatus {
  INDEPENDANT = "INDEPENDANT",
  SALARIE = "SALARIE",
}

export enum DiscussionMessageType {
  AUDIO = "AUDIO",
  TEXT = "TEXT",
}

export enum PhysicalModel {
  WITHOUT_AGENCY = "WITHOUT_AGENCY",
  WITH_AGENCY = "WITH_AGENCY",
}

export enum SortOrder {
  asc = "asc",
  desc = "desc",
}

export enum StepName {
  ACCEPTED = "ACCEPTED",
  ACCOUNTING_PERFORMED = "ACCOUNTING_PERFORMED",
  ADDITIONAL_DOCUMENTS = "ADDITIONAL_DOCUMENTS",
  ADDITIONAL_DOCUMENTS_RECEIVED = "ADDITIONAL_DOCUMENTS_RECEIVED",
  ADMISSIBLE = "ADMISSIBLE",
  APPOINTMENT_MADE = "APPOINTMENT_MADE",
  APPOINTMENT_WITHOUT_ACTION = "APPOINTMENT_WITHOUT_ACTION",
  BAILIFF_ESCROW = "BAILIFF_ESCROW",
  BANK_AGREEMENT_RESERVATIONS = "BANK_AGREEMENT_RESERVATIONS",
  BANK_DELAY = "BANK_DELAY",
  BANK_INVOICE_SENT = "BANK_INVOICE_SENT",
  BANK_REFUSAL = "BANK_REFUSAL",
  BANK_SENT = "BANK_SENT",
  CALL_FOR_FUNDS_RECEIVED = "CALL_FOR_FUNDS_RECEIVED",
  CANCELED = "CANCELED",
  CLIENT_INJOIGNABLE = "CLIENT_INJOIGNABLE",
  CLOSED = "CLOSED",
  COMMISSION_PAYED = "COMMISSION_PAYED",
  COMPLIANT_OFFER = "COMPLIANT_OFFER",
  CONFIRMED = "CONFIRMED",
  CUSTOMER_FEEDBACK = "CUSTOMER_FEEDBACK",
  CUSTOMER_INVOICE_SENT = "CUSTOMER_INVOICE_SENT",
  CUSTOMER_REFUSAL = "CUSTOMER_REFUSAL",
  DELEGATED_INSURANCE = "DELEGATED_INSURANCE",
  EDITED_BANK_ACCEPTANCE = "EDITED_BANK_ACCEPTANCE",
  EDITED_SEND_MANDATE = "EDITED_SEND_MANDATE",
  ELIGIBLE_DOCUMENT_COUNTERSIGNED = "ELIGIBLE_DOCUMENT_COUNTERSIGNED",
  ELIGIBLE_DOCUMENT_PENDING = "ELIGIBLE_DOCUMENT_PENDING",
  FILE_REALIZED = "FILE_REALIZED",
  FUNDS_RELEASED = "FUNDS_RELEASED",
  GROUP_INSURANCE = "GROUP_INSURANCE",
  INELIGIBLE_DOCUMENT = "INELIGIBLE_DOCUMENT",
  INTERNAL_REJECTION = "INTERNAL_REJECTION",
  LOAN_GENERATED = "LOAN_GENERATED",
  NON_COMPLIANT_OFFER = "NON_COMPLIANT_OFFER",
  NON_ESCROW = "NON_ESCROW",
  NOTARIZED_CERTIFICATE_RECEIVED = "NOTARIZED_CERTIFICATE_RECEIVED",
  NOTE_AND_VOUCHERS_RECEIVED = "NOTE_AND_VOUCHERS_RECEIVED",
  OFFER_EDITED = "OFFER_EDITED",
  OFFER_RECEIVED = "OFFER_RECEIVED",
  OFFER_SINGNED = "OFFER_SINGNED",
  OPENED_ACCOUNT_AND_INSURANCE = "OPENED_ACCOUNT_AND_INSURANCE",
  PENDING_PROJECT = "PENDING_PROJECT",
  PRE_ACCOUNTING_DONE = "PRE_ACCOUNTING_DONE",
  REALIZED_DOCUMENT = "REALIZED_DOCUMENT",
  REEDITED_OFFER = "REEDITED_OFFER",
  REFUSED_OFFER = "REFUSED_OFFER",
  REJECTED = "REJECTED",
  RESERVES_RAISED = "RESERVES_RAISED",
  SALE_CANCELED = "SALE_CANCELED",
  SCHEDULED_APPOINTMENT = "SCHEDULED_APPOINTMENT",
  SCROW_RESTITUTION_REQUESTED = "SCROW_RESTITUTION_REQUESTED",
  SIGNED_BANK_ACCEPTANCE = "SIGNED_BANK_ACCEPTANCE",
  SIGNED_MANDATE = "SIGNED_MANDATE",
  TREATED_RESERVES = "TREATED_RESERVES",
  UNSIGNED_MANDATE = "UNSIGNED_MANDATE",
  VISA_NOT_OK = "VISA_NOT_OK",
  VISA_OK = "VISA_OK",
}

/**
 * -------------------- Enums -------------------------------------#
 */
export enum TypeEnseigne {
  BANK = "BANK",
  CONNECTCREDIT = "CONNECTCREDIT",
  HERITAGE_MANAGEMENT = "HERITAGE_MANAGEMENT",
  INSURANCE = "INSURANCE",
  NOTARIAT = "NOTARIAT",
  OTHER = "OTHER",
  PARRAINAGE = "PARRAINAGE",
  REAL_ESTATE_PROMOTION = "REAL_ESTATE_PROMOTION",
  REAL_ESTATE_TRANSACTION = "REAL_ESTATE_TRANSACTION",
}

export interface AddUsersInEntityInput {
  entityId: number;
  userIds: number[];
}

export interface AdminEditUserInput {
  userId: number;
  civility?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  phone?: string | null;
  email?: string | null;
  apaStatus?: ApaStatus | null;
  siren?: string | null;
  rib?: string | null;
  iban?: string | null;
  secu?: string | null;
  roles?: (string | null)[] | null;
  enseigneId?: number | null;
  entityIds?: number[] | null;
  managedEntityIds?: number[] | null;
  totalDefaultCommission?: number | null;
  defaultCommissionDistributions?: DefaultCommissionInput[] | null;
  function?: string | null;
  idCRM?: number | null;
  isDeleted?: boolean | null;
}

export interface AllBusinessesInput {
  take?: number | null;
  skip?: number | null;
  where?: BusinessWhereInput | null;
  orderBy?: BusinessOrderByInput | null;
}

export interface AllEnseignesInput {
  take?: number | null;
  skip?: number | null;
  onlyApaRelated?: boolean | null;
  where?: EnseigneWhereInput | null;
  orderBy?: EnseigneOrderByInput | null;
}

export interface AllEntitiesInput {
  take?: number | null;
  skip?: number | null;
  onlyApaRelated?: boolean | null;
  where?: EntityWhereInput | null;
  orderBy?: EntityOrderByInput | null;
}

export interface AllMessageUnseenInput {
  isBackoffice?: boolean | null;
}

export interface BusinessOrderByInput {
  idCC?: SortOrder | null;
  createdAt?: SortOrder | null;
  assignedAt?: SortOrder | null;
  unblockedAt?: SortOrder | null;
  signedByNotaryAt?: SortOrder | null;
  email?: SortOrder | null;
  phone?: SortOrder | null;
  firstName?: SortOrder | null;
  lastName?: SortOrder | null;
  step?: SortOrder | null;
  apa?: UserOrderByInput | null;
  mandatary?: UserOrderByInput | null;
  redirectedFrom?: UserOrderByInput | null;
}

export interface BusinessWhereInput {
  idCC?: number | null;
  idCRM?: number | null;
  createdAt?: any | null;
  assignedAt?: any | null;
  unblockedAt?: any | null;
  signedByNotaryAt?: any | null;
  email?: string | null;
  phone?: string | null;
  name?: string | null;
  step?: string | null;
  apa?: UserWhereInput | null;
  mandatary?: UserWhereInput | null;
  redirectedFrom?: UserWhereInput | null;
}

export interface ChangeBusinessDatesInput {
  businessId: number;
  createdAt?: any | null;
  unblockedAt?: any | null;
  signedByNotaryAt?: any | null;
}

export interface ChangeBusinessEstimationsInput {
  businessId: number;
  estimatedMaxPurchase?: number | null;
  estimatedMaxLoan?: number | null;
}

export interface ChangeBusinessStatusInput {
  id: number;
  status: StepName;
  isBackoffice?: boolean | null;
  activeSync?: boolean | null;
}

export interface CommissionInput {
  commissionId?: number | null;
  amount?: number | null;
  beneficiaryId?: number | null;
}

export interface CompaignInput {
  compaignId?: number | null;
}

export interface CompaignsInput {
  take?: number | null;
  skip?: number | null;
}

export interface CreateBusinessInput {
  idCRM?: number | null;
  email: string;
  phone?: string | null;
  firstName: string;
  lastName?: string | null;
  addRecord?: boolean | null;
  access: string;
  isFormal?: boolean | null;
  apaId?: number | null;
  mandataryId?: number | null;
  managerId?: number | null;
  withConfirmationCode?: boolean | null;
  withEmailOrSMS?: boolean | null;
  withNotification?: boolean | null;
}

export interface CreateCompaignInput {
  title?: string | null;
  desc?: string | null;
  userIds?: number[] | null;
  text?: string | null;
}

/**
 * -------------------- Inputs -------------------------------------#
 */
export interface CreateDiscussionInput {
  name?: string | null;
  userIds: number[];
}

export interface CreateEchelonInput {
  name: string;
  priority: number;
}

export interface CreateEnseigneInput {
  type?: TypeEnseigne | null;
  name: string;
  address?: string | null;
  country?: string | null;
  zipCode?: string | null;
  city?: string | null;
  phone?: string | null;
  email?: string | null;
  SIRET?: string | null;
  SIREN?: string | null;
  IBAN?: string | null;
  BIC?: string | null;
  physicalModel?: PhysicalModel | null;
  socialReason?: string | null;
  echelonIds?: number[] | null;
  entityIds?: number[] | null;
}

export interface CreateEntityInput {
  isImported?: boolean | null;
  name: string;
  enseigneId: number;
  echelonId: number;
  parentEntityId?: number | null;
  userIds?: number[] | null;
  latitude?: number | null;
  longitude?: number | null;
  adress: string;
  zipCode: string;
  town: string;
  email?: string | null;
  phone?: string | null;
  siret?: string | null;
  reseauId?: number | null;
  idCRM?: number | null;
}

export interface CreateFeedbackInput {
  text?: string | null;
  contentType: DiscussionMessageType;
}

export interface CreateUserInput {
  email?: string | null;
  phone?: string | null;
  civility?: string | null;
  firstName: string;
  lastName?: string | null;
  agency?: string | null;
  agencyAddress?: string | null;
  roles: string[];
  mandataryId?: number | null;
  brandOrStudyName?: string | null;
  enseignId?: number | null;
  agencyId?: number | null;
  isMobile?: boolean | null;
  withEmail?: boolean | null;
}

export interface DefaultCommissionInput {
  commissionId?: number | null;
  amount: number;
  beneficiaryId: number;
}

export interface DeleteEchelonInput {
  id: number;
}

export interface DeleteEnseigneInput {
  id: number;
}

export interface DiscussionMessagesInput {
  discussionId?: number | null;
  businessId?: number | null;
  tags?: string[] | null;
  take?: number | null;
  skip?: number | null;
}

export interface DiscussionMessagesSeenInput {
  discussionId?: number | null;
  messageIds?: number[] | null;
}

export interface DiscussionsInput {
  userIds?: number[] | null;
  tags?: string[] | null;
  filter?: string | null;
  onlyArchived?: boolean | null;
  isBackoffice?: boolean | null;
  take?: number | null;
  skip?: number | null;
}

/**
 * -------------------- Inputs -------------------------------------#
 */
export interface EchelonWhereInput {
  name?: string | null;
  priority?: IntFilter | null;
}

export interface EnseigneOrderByInput {
  idCC?: SortOrder | null;
  idCRM?: SortOrder | null;
  type?: SortOrder | null;
  name?: SortOrder | null;
  address?: SortOrder | null;
  country?: SortOrder | null;
  zipCode?: SortOrder | null;
  city?: SortOrder | null;
  phone?: SortOrder | null;
  email?: SortOrder | null;
  SIRET?: SortOrder | null;
  SIREN?: SortOrder | null;
  IBAN?: SortOrder | null;
  BIC?: SortOrder | null;
  physicalModel?: SortOrder | null;
  socialReason?: SortOrder | null;
  createdAt?: SortOrder | null;
}

/**
 * -------------------- Inputs -------------------------------------#
 */
export interface EnseigneWhereInput {
  idCC?: number | null;
  idCRM?: number | null;
  type?: string | null;
  name?: string | null;
  address?: string | null;
  country?: string | null;
  zipCode?: string | null;
  city?: string | null;
  phone?: string | null;
  email?: string | null;
  SIRET?: string | null;
  SIREN?: string | null;
  IBAN?: string | null;
  BIC?: string | null;
  physicalModel?: string | null;
  socialReason?: string | null;
  createdAt?: any | null;
  tags?: string[] | null;
  isImported?: boolean | null;
}

export interface EntityOrderByInput {
  idCC?: SortOrder | null;
  idCRM?: SortOrder | null;
  name?: SortOrder | null;
  enseigne?: EnseigneOrderByInput | null;
  network?: EntityOrderByInput | null;
  parent?: EntityOrderByInput | null;
  echelon?: SortOrder | null;
  createdAt?: SortOrder | null;
  address?: SortOrder | null;
  zipCode?: SortOrder | null;
  town?: SortOrder | null;
  email?: SortOrder | null;
  phone?: SortOrder | null;
  siret?: SortOrder | null;
}

/**
 * ------------------- Inputs ------------------- #
 */
export interface EntityWhereInput {
  idCC?: number | null;
  idCRM?: number | null;
  enseignes?: EnseigneWhereInput[] | null;
  network?: EntityWhereInput | null;
  parent?: EntityWhereInput | null;
  echelon?: EchelonWhereInput | null;
  createdAt?: any | null;
  address?: string | null;
  zipCode?: string | null;
  name?: string | null;
  town?: string | null;
  email?: string | null;
  phone?: string | null;
  siret?: string | null;
}

export interface GetAllEchelonsInput {
  take?: number | null;
  skip?: number | null;
  filter?: string | null;
}

export interface GetAllUserInEnseigneInput {
  enseigneId: number;
  echelonPriority?: number | null;
}

export interface GetAllUsersInput {
  take?: number | null;
  skip?: number | null;
  autoComplete?: boolean | null;
  where?: UserWhereInput | null;
  orderBy?: UserOrderByInput | null;
}

export interface GetEchelonInput {
  id: number;
}

export interface GetEnseigneInput {
  id: number;
}

export interface ImportEnseignesInput {
  datas: ImportEnseignesInputDatas[];
}

export interface ImportEnseignesInputDatas {
  enseigneName?: string | null;
  agencyName?: string | null;
  agencySiret?: string | null;
  agencyPhone?: string | null;
  agencyEmail?: string | null;
  agencyAdress?: string | null;
  agencyZipCode?: string | null;
  agencyTown?: string | null;
  managerName?: string | null;
  managerEmail?: string | null;
  managerPhone?: string | null;
}

export interface ImportEntitiesInput {
  echelonPriority?: number | null;
  enseigneId?: string | null;
  enseigneName?: string | null;
  enseigneType?: TypeEnseigne | null;
  enseignePhysicalModel?: PhysicalModel | null;
  agencyName?: string | null;
  agencySiret?: string | null;
  agencyPhone?: string | null;
  agencyEmail?: string | null;
  agencyAddress?: string | null;
  agencyZipCode?: string | null;
  agencyTown?: string | null;
}

export interface IntFilter {
  equals?: number | null;
  in?: number[] | null;
  notIn?: number[] | null;
  lt?: number | null;
  lte?: number | null;
  gt?: number | null;
  gte?: number | null;
  not?: number | null;
}

export interface MandataryRateInput {
  year: number;
  exellentRate: number;
  teg: number;
  goodRate: number;
}

export interface PermissionInput {
  resource?: string | null;
  create?: boolean | null;
  read?: boolean | null;
  update?: boolean | null;
  delete?: boolean | null;
  import?: boolean | null;
  export?: boolean | null;
}

export interface QueryAllStepInput {
  take?: number | null;
  skip?: number | null;
}

export interface RemunerationInput {
  remunerationId?: number | null;
  clientHonorary?: number | null;
  bankCommission?: number | null;
  bankId?: number | null;
}

export interface SendMessageToCompaignInput {
  compaignId?: number | null;
}

/**
 * Choose between discussionId and userIds.
 * Current user id will be used if no senderId.
 */
export interface SendMessageToDiscussionInput {
  senderId?: number | null;
  discussionId?: number | null;
  userIds?: number[] | null;
  quotedFromId?: number | null;
  text?: string | null;
  uri?: string | null;
  contentType: DiscussionMessageType;
  businessId?: number | null;
  noPushNotif?: boolean | null;
  tags?: string[] | null;
}

export interface SetRolesInput {
  role?: string | null;
  permissions?: (PermissionInput | null)[] | null;
}

export interface SetUserEntitiesInput {
  userId: number;
  enseigneId: number;
  entityIds?: number[] | null;
}

export interface SetUserManageOneEntityInput {
  userId: number;
  entityId: number;
  isManager: boolean;
}

export interface SetUserManagedEntitiesInput {
  userId: number;
  entityIds?: number[] | null;
}

export interface SetUserManagerInput {
  userId: number;
  isManager: boolean;
}

export interface SetUserPermissionsInput {
  userId?: number | null;
  permissions?: (PermissionInput | null)[] | null;
}

export interface UpdateBusinessInput {
  businessId: number;
  email?: string | null;
  phone?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  remuneration?: RemunerationInput | null;
  commissions?: CommissionInput[] | null;
  status?: StepName | null;
  isBackoffice?: boolean | null;
  idCRM?: number | null;
  apaId?: number | null;
  mandataryId?: number | null;
  managerId?: number | null;
}

export interface UpdateEchelonInput {
  id: number;
  name?: string | null;
  priority?: number | null;
}

export interface UpdateEnseigneInput {
  id: number;
  type?: TypeEnseigne | null;
  name?: string | null;
  address?: string | null;
  country?: string | null;
  zipCode?: string | null;
  city?: string | null;
  phone?: string | null;
  email?: string | null;
  SIRET?: string | null;
  SIREN?: string | null;
  IBAN?: string | null;
  BIC?: string | null;
  physicalModel?: PhysicalModel | null;
  socialReason?: string | null;
  echelonIds?: number[] | null;
  entityIds?: number[] | null;
}

export interface UpdateEntityInput {
  name: string;
  entityId: number;
  enseigneId: number;
  echelonId: number;
  parentEntityId?: number | null;
  userIds?: number[] | null;
  latitude?: number | null;
  longitude?: number | null;
  adress: string;
  zipCode: string;
  town: string;
  email?: string | null;
  phone?: string | null;
  siret?: string | null;
  reseauId?: number | null;
  idCRM?: number | null;
}

export interface UpsertEntityInput {
  name: string;
  entityId?: number | null;
  enseigneId: number;
  echelonId: number;
  parentEntityId?: number | null;
  userIds?: number[] | null;
  latitude?: number | null;
  longitude?: number | null;
  adress: string;
  zipCode: string;
  town: string;
  email?: string | null;
  phone?: string | null;
  siret?: string | null;
  reseauId?: number | null;
  idCRM?: number | null;
}

export interface UserFilterInput {
  filter?: string | null;
  mandataryId?: number | null;
  onlyWhoseSendBusiness?: boolean | null;
  take?: number | null;
  skip?: number | null;
}

export interface UserOrderByInput {
  idCC?: SortOrder | null;
  idCRM?: SortOrder | null;
  createdAt?: SortOrder | null;
  email?: SortOrder | null;
  phone?: SortOrder | null;
  civility?: SortOrder | null;
  firstName?: SortOrder | null;
  lastName?: SortOrder | null;
  isBlocked?: SortOrder | null;
  isManager?: SortOrder | null;
  enseigne?: EnseigneOrderByInput | null;
}

export interface UserWhereInput {
  idCC?: number | null;
  idCCNotIn?: number[] | null;
  idCRM?: number | null;
  createdAt?: any | null;
  civility?: string | null;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  enseigneName?: string | null;
  entities?: string | null;
  agencyName?: string | null;
  roles?: (string | null)[] | null;
  isBlocked?: boolean | null;
  isMobile?: boolean | null;
  isManager?: boolean | null;
  mandataryIds?: number[] | null;
  enseigneIds?: number[] | null;
  entityIds?: number[] | null;
}

export interface collaboratorsInput {
  userId?: number | null;
  userIdNotIn?: number[] | null;
  onlyManager?: boolean | null;
  role?: string[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
